import { render } from "./AddNewCompanyBoardItem.vue?vue&type=template&id=3a51403c&ts=true"
import script from "./AddNewCompanyBoardItem.vue?vue&type=script&lang=ts"
export * from "./AddNewCompanyBoardItem.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__